import ChipsInput from './ChipsInput';

export default ChipsInput;
